const validate = (values) => {
  const errors = {};
  if (!values.phone) {
    errors.phone = 'Введите телефон';
  } else if (values.phone.replace(/\D/g, '').length < 11) {
    errors.phone = 'Неверный телефон';
  }
  if (!values.name) {
    errors.name = 'Введите имя';
  }
  if (!values.companyName) {
    errors.companyName = 'Введите название компании';
  }
  if (!values.soname) {
    errors.soname = 'Введите фамилию';
  }
  if (!values.company) {
    errors.company = 'Введите название компании';
  }
  if (!values.countUsers) {
    errors.countUsers = 'Выберите кол-во сотрудников';
  }
  if (!values.rules) {
    errors.rules = 'Согласитесь с правилами';
  }
  if (!values.position) {
    errors.position = 'Введите должность';
  } else if (values.position.length > 30) {
    errors.position = 'Слишком длинная должность';
  }
  return errors;
};

export default validate;



// WEBPACK FOOTER //
// ./src/components/Payments/RequestToConnect/validate.js